/**
 * Shared hook to fetch country name options from ref_country_codes.
 * Returns { value: countryCode, label: "CountryName (CC)" } options
 * suitable for dropdown use in FilterBuilder.
 *
 * Cached via react-query with a long staleTime — the table rarely changes.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { endpoints } from '@/services/endpoints';

interface CountryRow {
  countryCode: string;
  countryName: string;
}

export function useCountryOptions() {
  const { data: countries = [] } = useQuery<CountryRow[]>({
    queryKey: ['ref', 'countries'],
    queryFn: () => api.get<CountryRow[]>(endpoints.marketing.countries()),
    staleTime: 60 * 60 * 1000, // 1 hour
  });

  const options = countries.map((c) => ({
    value: c.countryCode,
    label: `${c.countryName} (${c.countryCode})`,
  }));

  return options;
}
